export default "__VITE_ASSET__dfe88983__"